export enum AuthFieldsNames {
  EMAIL = 'email',
  CURRENT_PASSWORD = 'current_password',
  PASSWORD = 'password',
  NEW_PASSWORD = 'new_password',
  CONFIRM_PASSWORD = 'confirm_password',
  OTP_CODE = 'otp_code',
}

export type TSignInFormValues = {
  [AuthFieldsNames.EMAIL]: string;
  [AuthFieldsNames.PASSWORD]: string;
};

export type TCreateNewPasswordFormValues = {
  [AuthFieldsNames.NEW_PASSWORD]: string;
};

export type TChangePasswordFormValues = {
  [AuthFieldsNames.CURRENT_PASSWORD]: string;
  [AuthFieldsNames.PASSWORD]: string;
  [AuthFieldsNames.NEW_PASSWORD]: string;
};

export type TSignInOtpCodeFormValues = {
  [AuthFieldsNames.OTP_CODE]: string;
};

export type TForgotPasswordFormValues = {
  [AuthFieldsNames.EMAIL]: string;
};

export type TResetPasswordFormValues = {
  [AuthFieldsNames.NEW_PASSWORD]: string;
};
